<template>
	<div class="leftside-menu menuitem-active">
		<!-- LOGO -->
		<div class="logo text-center logo-light">
			<span class="logo-lg">
				<img :src="appLogo" alt="inv-lg" height="40" />
			</span>
			<span class="logo-sm">
				<img :src="appIcon" height="50" class="w-100 p-2" alt="inv-sm" />
			</span>
		</div>

		<button class="sidebar-collapse-btn hidden" @click="toggleSidebar">
			<i class="bi bi-chevron-double-left text-white"></i>
		</button>

		<!-- LOGO -->

		<div id="leftside-menu-container" class="h-100 show" data-simplebar="init">
			<div class="simplebar-wrapper" style="margin: 0px">
				<div class="simplebar-height-auto-observer-wrapper">
					<div class="simplebar-height-auto-observer"></div>
				</div>
				<div class="simplebar-mask">
					<div class="simplebar-offset" style="right: 0px; bottom: 0px">
						<div
							class="simplebar-content-wrapper d-flex justify-content-between flex-column"
							style="height: 100%; overflow: hidden scroll"
						>
							<div class="simplebar-content" style="padding: 0px">
								<div class="d-flex justify-content-between flex-column">
									<ul class="side-nav" :class="activeSlug">
										<!-- <li class="side-nav-title side-nav-item">Apps</li> -->

										<li v-for="(menu, index) in filteredMenus" :key="index" class="side-nav-item" @click="closeSidebarMobile" :class="{'side-nav-title': menu.is_title}">
											<template v-if="!menu.is_title">
												<router-link
													v-if="!menu.submenus"
													:to="menu.link"
													class="side-nav-link"
													:class="{ 'rl-active': menu.slug === activeSlug }"
													@click="hasSubmenuActive = '	'"
												>
													<div v-tooltip="menu.label.length > 20 ? menu.label : ''" class="ellipsis-text">
														<i :class="menu.icon"></i>
														<span> {{ menu.label }}</span>
													</div>
													<div v-tooltip="menu.info || ''" v-if="menu.stats_value">
														<span class="mt-0 badge badge-primary">{{ getDisplayStats(menu.stats_value) }}</span>
													</div>
												</router-link>
												<div
													v-else
													:class="{
														'side-nav-link cursor-pointer': true,
														'rl-active': menu.slug === activeSlug,
														active: hasSubmenuActive === menu.link,
													}"
													@click="toggleMenu(menu.link)"
												>
													<div>
														<i :class="menu.icon"></i>
														<span> {{ menu.label }} </span>
													</div>
													<div class="submenu-icon">
														<i
															:class="`bi-chevron-right arrow-submenu ${
																expandedSubmenu === menu.link && 'expanded'
															}`"
														/>
													</div>
												</div>
												<!-- submenus -->
												<div v-if="expandedSubmenu === menu.link" class="side-nav-submenu" :class="{'is-absolute' : !isSidebarShow}">
													<div v-for="(item, i) in menu.submenus" :key="i">
														<router-link
															:to="item.link"
															class="side-nav-link"
															@click="hasSubmenuActive = menu.link"
															v-if="isHasMenuAccess(item)"
														>
															<span> {{ item.label }} </span>
															<div v-tooltip="item.info || ''" v-if="item.stats_value">
																<span class="mt-0 badge badge-primary">{{ getDisplayStats(item.stats_value) }}</span>
															</div>
														</router-link>
													</div>
												</div>
											</template>
											<template v-else>
												{{ menu.label }}
											</template>
										</li>
									</ul>
								</div>
								<!--- Sidemenu -->

								<!-- End Sidebar -->

								<div class="clearfix"></div>
							</div>
							<div class="simplebar-content" style="padding: 0px">
								<!--- Sidemenu Tutorial -->
								<ul class="side-nav">
									<!-- <li class="side-nav-item">
										<a href="https://help.ostock.id" target="_blank" class="side-nav-link">
											<div>
												<i :class="'uil-book'"></i>
												<span> Tutorial </span>
											</div>
										</a>
									</li> -->
									<!-- <li class="side-nav-item menuitem-create-order mt-3 mb-3">
										<a
											href="https://help.ostock.id"
											target="_blank"
											class="side-nav-link btn btn-outline-primary"
										>
											<div class="text-center">
												<i class="uil-external-link-alt"></i>
												<span>Pusat Bantuan</span>
											</div>
										</a>
									</li> -->
								</ul>

								<!--- End Sidemenu Tutorial -->

								<div class="clearfix"></div>
							</div>
						</div>
					</div>
				</div>
				<div class="simplebar-placeholder" style="width: 260px; height: 2374px"></div>
			</div>
			<div class="simplebar-track simplebar-horizontal" style="visibility: hidden">
				<div
					class="simplebar-scrollbar"
					style="width: 0px; display: none; transform: translate3d(0px, 0px, 0px)"
				></div>
			</div>
			<div class="simplebar-track simplebar-vertical" style="visibility: visible">
				<div
					class="simplebar-scrollbar"
					style="height: 56px; transform: translate3d(0px, 0px, 0px); display: block"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import { getAxiosErrorMessage } from '@/lib/helper';
import { statItems } from '@/lib/statics';

export default {
	props: {
		activeSlug: {
			type: String,
			default: '',
		},
	},
	data: () => ({
		expandedSubmenu: '',
		hasSubmenuActive: '',
		menus: [
			// General
			{
				label: 'General',
				is_title: true,
				capabilities: ['admin_home_view', 'admin_statistic_view', 'admin_users_view', 'admin_supplier_view', 'admin_monitoring_orders_view', 'admin_product_view', 'admin_setting_view'],
			},
			{
				label: 'Home',
				icon: 'bi-house-door',
				link: '/admin',
				slug: 'admin',
				capabilities: 'admin_home_view',
			},
			{
				label: 'Statistic',
				icon: 'bi-bar-chart-line',
				link: '/admin/stats',
				slug: 'statistics',
				capabilities: 'admin_statistic_view',
			},
			{
				label: 'Users',
				icon: 'bi-people',
				link: '/admin/user',
				slug: 'user',
				capabilities: 'admin_users_view',
				submenus: [
					{
						label: 'Staff',
						icon: 'bi-people',
						link: '/admin/user/staff',
						slug: 'user',
						capabilities: ['admin_users_staff_view'],
					},
					// {
					// 	label: 'Suppliers',
					// 	icon: 'bi-person-bounding-box',
					// 	link: '/admin/user/supplier',
					// 	slug: 'supplier',
					// 	capabilities: 'admin_supplier_view',
					// 	stats_value: 0,
					// 	info: 'Total Requested Suppliers',
					// },
					{
						label: 'Suppliers',
						icon: 'bi-person-bounding-box',
						link: '/admin/supplier',
						slug: 'user',
						capabilities: ['admin_supplier_view'],
						stats_value: 0,
						info: 'Total Requested Suppliers',
					},
					{
						label: 'Seller',
						icon: 'bi-people',
						link: '/admin/user/seller',
						slug: 'user',
						capabilities: ['admin_users_view'],
					},
				],
			},
			{
				label: 'Orders Monitoring',
				icon: 'bi-search',
				link: '/admin/orders',
				slug: 'orders',
				capabilities: 'admin_monitoring_orders_view',
			},
			{
				label: 'Wholesale Orders',
				info: 'Wholesale Orders',
				icon: 'bi-search-heart',
				link: '/admin/wholesale-order',
				slug: 'private-order',
				capabilities: 'admin_private_order_view',
			},
			{
				label: 'Monitoring Fraud',
				icon: 'bi-person-exclamation',
				link: '/admin/fraud-monitoring',
				slug: 'fraud-monitoring',
				capabilities: 'admin_fraud_monitoring_view',
			},
			{
				label: 'Leads Order',
				icon: 'bi-cart',
				link: '/admin/leads-order',
				slug: 'leads-order',
				capabilities: 'admin_leads_order_view',
			},
			{
				label: 'Warehouses',
				icon: 'bi-house',
				link: '/admin/warehouse',
				slug: 'admin_warehouse',
				capabilities: 'admin_homepage_view',
			},
			{
				label: 'Announcements',
				icon: 'bi-megaphone',
				link: '/admin/announcements',
				slug: 'admin_announcements',
				capabilities: 'admin_homepage_view',
			},
			{
				label: 'Popup Information',
				icon: 'bi-box-arrow-in-up-right',
				link: '/admin/popup-information',
				slug: 'popup-information',
				capabilities: 'admin_popup_information_view',
			},
			{
				label: 'Settings',
				icon: 'bi-gear',
				link: '/admin/settings',
				slug: 'settings',
				capabilities: 'admin_setting_view',
			},
			{
				label: 'Log Activities',
				icon: 'bi-clock-history',
				link: '/admin/activity-log',
				slug: 'activity-log',
				capabilities: 'admin_activity_log_view',
			},
			{
				label: 'Export Page',
				icon: 'bi-file-earmark-spreadsheet',
				link: '/admin/export-page',
				slug: 'export-page',
				capabilities: 'admin_export_page_view',
			},
			{
				label: 'OTP Page',
				icon: 'bi bi-key',
				link: '/admin/otp',
				slug: 'admin-otp',
				capabilities: 'admin_otp_page_view',
			},

			// Product
			{
				label: 'Product',
				is_title: true,
				capabilities: ['admin_product_view', 'admin_ticket_view', 'admin_ask_stock_view'],
			},
			{
				label: 'Product List',
				icon: 'bi-bag',
				link: '/admin/products',
				slug: 'products',
				capabilities: 'admin_product_view',
				stats_value: 0,
				info: 'Total Pricing - Updated Products',
			},
			{
				label: 'Tanyakan Stock',
				icon: 'bi-chat-square-dots',
				link: '/admin/ask-stocks',
				slug: 'ask-stocks',
				capabilities: 'admin_ask_stock_view',
				stats_value: 0,
				info: 'New',
			},
			{
				label: 'Marketing Kit',
				icon: 'bi-image',
				link: '/admin/marketing-kit',
				slug: 'admin_product_content',
				capabilities: 'admin_product_view',
			},
			{
				label: 'Monitoring Ticket',
				icon: 'bi-ticket-perforated',
				link: '/admin/ticket',
				slug: 'ticket',
				capabilities: 'admin_ticket_view',
				stats_value: 0,
				info: 'Status Open',
			},
			{
				label: 'Monitoring Stock',
				icon: 'bi-boxes',
				link: '/admin/monitoring-stock',
				slug: 'monitoring-stock',
				capabilities: 'admin_monitoring_stock_view',
			},
			{
				label: 'Change Source',
				icon: 'bi-arrow-left-right',
				link: '/admin/change-source',
				slug: 'change-source',
				capabilities: 'admin_change_source_view',
			},

			// Commercial
			{
				label: 'Commercial',
				is_title: true,
				capabilities: ['admin_sales_view', 'admin_monitoring_sales_view'],
			},
			{
				label: 'Sales',
				icon: 'bi-person-lines-fill',
				link: '/admin/sales',
				slug: 'sales',
				capabilities: 'admin_sales_view',
			},
			{
				label: 'Monitoring Sales',
				icon: 'bi-pie-chart',
				link: '/admin/monitoring-sales',
				slug: 'monitoring-sales',
				capabilities: 'admin_monitoring_sales_view',
			},

			// Finance
			{
				label: 'Finance',
				is_title: true,
				capabilities: ['admin_withdrawal_view', 'admin_billing_view', 'admin_finance_view'],
			},
			{
				label: 'Withdrawals',
				icon: 'bi-credit-card',
				link: '/admin/withdrawals',
				slug: 'withdrawals',
				capabilities: 'admin_withdrawal_view',
			},
			{
				label: 'Billings',
				icon: 'bi-receipt',
				link: '/admin/billings',
				slug: 'billings',
				capabilities: 'admin_billing_view',
			},
			{
				label: 'Finance',
				icon: 'bi-credit-card-2-front',
				link: '/admin/finance',
				slug: 'finance',
				capabilities: 'admin_finance_view',
			},
			{
				label: 'Supplier Wallet',
				icon: 'bi bi-wallet',
				link: '/admin/supplier-wallet',
				slug: 'supplier-wallet',
				capabilities: 'admin_finance_view',
			},
			{
				label: 'Seller Wallet',
				icon: 'bi bi-wallet',
				link: '/admin/dropshipper-wallet',
				slug: 'dropshipper-wallet',
				capabilities: 'admin_finance_view',
			},
			{
				label: 'Wallet Draft',
				icon: 'bi bi-wallet2',
				link: '/admin/wallet-draft',
				slug: 'wallet-draft',
				capabilities: 'admin_finance_view',
			},
			{
				label: 'Revenue New',
				icon: 'bi-cash-coin',
				link: '/admin/revenue-new',
				slug: 'revenue-new',
				capabilities: 'admin_finance_view',
			},
			{
				label: 'Revenue Stream',
				icon: 'bi-cash-coin',
				link: '/admin/revenue-stream',
				slug: 'revenue-stream',
				capabilities: 'admin_finance_view',
			},
			{
				label: 'Handling Fee',
				icon: 'bi-credit-card-2-back',
				link: '/admin/handling-fee',
				slug: 'handling-fee',
				capabilities: 'admin_finance_view',
			},
			{
				label: 'Seller Topup',
				icon: 'bi bi-wallet2',
				link: '/admin/seller-topup-monitoring',
				slug: 'seller-topup-monitoring',
				capabilities: 'admin_finance_view',
			},
			{
				label: 'Credit Cancel',
				icon: 'bi-cash-stack',
				link: '/admin/credit-cancel',
				slug: 'credit-cancel',
				capabilities: 'admin_credit_cancel',
			},
			// Request
			{
				label: 'Request',
				is_title: true,
				capabilities: ['admin_homepage_view'],
			},
			{
				label: 'Brand',
				icon: 'bi-tags',
				link: '/admin/brand',
				slug: 'admin_brand',
				capabilities: 'admin_homepage_view',
				stats_value: 0,
				info: 'Total Review Brands',
			},
			{
				label: 'Direct',
				icon: 'bi-folder-symlink',
				link: '/admin/direct',
				slug: 'admin_direct',
				capabilities: 'admin_homepage_view',
				stats_value: 0,
				info: 'Total Review Directs',
			},
			{
				label: 'Request Product',
				icon: 'bi-box2',
				link: '/admin/request-product',
				slug: 'admin_product_request',
				capabilities: 'admin_homepage_view',
				stats_value: 0,
				info: 'Total Review Request Products',
			},
			// Site
			{
				label: 'Site',
				is_title: true,
				capabilities: ['admin_slide_banner_view', 'admin_homepage_view'],
			},
			{
				label: 'Slider Banner',
				icon: 'bi-images',
				link: '/admin/slider',
				slug: 'slider',
				capabilities: 'admin_slide_banner_view',
			},
			{
				label: 'Slider Banner Supplier',
				icon: 'bi-image',
				link: '/admin/supplier-slider',
				slug: 'supplier-slider',
				capabilities: 'admin_slide_banner_view',
			},
			{
				label: 'Slider Banner Wholesale',
				icon: 'bi-image',
				link: '/admin/wholesale-slider',
				slug: 'wholesale-slider',
				capabilities: 'admin_slide_banner_view',
			},
			{
				label: 'Homepage',
				icon: 'bi-display',
				link: '/admin/homepage',
				slug: 'homepage',
				capabilities: 'admin_homepage_view',
			},
			// Others
			// {
			// 	label: 'Others',
			// 	is_title: true,
			// },
			// {
			// 	label: 'Back',
			// 	icon: 'bi-box-arrow-left',
			// 	link: '/',
			// 	slug: 'back',
			//  capabilities: '',
			// },
			// { // Sample Submenus
			// 	label: 'Riwayat Kiriman',
			// 	icon: 'uil-history',
			// 	link: '/orders',
			// 	submenus: [
			// 		{
			// 			label: 'Batch',
			// 			link: '/orders/Batch',
			// 		},
			// 		{
			// 			label: 'Semua',
			// 			link: '/orders',
			// 		},
			// 	],
			// },
		],
		source: null,
		selectedStats: [
			'users',
			'products',
			'brands',
			'directs',
			'product_requests',
			'ask_stock',
			'ticket',
		],
		appIcon: process.env?.VUE_APP_ICON ?? 'https://cdn.ostock.id/img/ostock-icon.svg',
	}),
	computed: {
		...mapGetters({
			isSidebarShow: 'isSidebarShow',
			isUserCan: 'isUserCan',
			appLogo: 'appLogo',
			statistic: 'sidebar/statistic',
			getAskStockNewCount: 'sidebar/getAskStockNewCount',
		}),
		filteredMenus() {
			return this.menus.filter(curr => (curr.is_title ? this.isHasMenuAccess(curr) : this.isUserCan(curr.capabilities)));
		},
	},
	methods: {
		...mapActions({
			toggleSidebar: 'toggleSidebar',
			closeSidebarMobile: 'closeSidebarMobile',
			getStatistic: 'sidebar/getStatistic',
		}),
		toggleMenu(menuLink) {
			this.expandedSubmenu = this.expandedSubmenu !== menuLink ? menuLink : '';
		},
		isHasMenuAccess(menu) {
			let hasAccess = false;
			menu.capabilities.forEach((capability) => {
				if (this.isUserCan(capability)) {
					hasAccess = true;
				}
			});
			return hasAccess;
		},
		fetchData() {
			const filteredStats = statItems.filter(item => this.selectedStats.includes(item));

			const params = {
				items: filteredStats.join(','),
			};

			if (this.source) {
				this.source.cancel('Operation canceled by the user.');
			}

			const CancelToken = axios.CancelToken;
			this.source = CancelToken.source();

			const sourceToken = this.source.token;

			const data = {
				params,
				sourceToken,
				callback: () => {
					this.getStats();
				},
				errorCallback: (e) => {
					const message = getAxiosErrorMessage(e);
					this.$notify({
						group: 'app',
						title: 'Statistics',
						text: message,
						type: 'error',
					});
				},
			};

			this.getStatistic(data);
		},
		assignStats(slug, value) {
			const selectedMenuIndex = this.menus.findIndex(menu => menu.slug === slug);
			if (selectedMenuIndex !== -1) {
				this.menus[selectedMenuIndex].stats_value = value;
			}
		},
		assignStatsToSubmenu(slug, value, submenu) {
			const selectedMenuIndex = this.menus.findIndex(menu => menu.slug === slug);
			if (selectedMenuIndex !== -1) {
				const selectedSubMenuIndex = this.menus[selectedMenuIndex].submenus.findIndex(menu => menu.slug === submenu);
				if (selectedMenuIndex !== -1) {
					this.menus[selectedMenuIndex].submenus[selectedSubMenuIndex].stats_value = value;
				}
			}
		},
		getStats() {
			const supplierRequestedCount = this.statistic?.users?.supplier_requested_count ?? 0;

			const productPricingCount = this.statistic?.products?.pricing_count ?? 0;
			const productRecontentCount = this.statistic?.products?.recontent_count ?? 0;
			const productLandingPageCount = this.statistic?.products?.landing_page_count ?? 0;
			const productVerificationCount = this.statistic?.products?.requested_count ?? 0;
			const productUpdatedCount = this.statistic?.products?.updated_count ?? 0;
			const totalProductCount = productPricingCount + productRecontentCount + productLandingPageCount + productVerificationCount + productUpdatedCount;

			const brandReviewCount = this.statistic?.brands?.brand_review_count ?? 0;
			const directReviewCount = this.statistic?.directs?.direct_review_count ?? 0;
			const productRequestReviewCount = this.statistic?.product_requests?.product_request_review_count ?? 0;

			const askStockNewCount = this.statistic?.ask_stocks?.ask_stock_new_count ?? 0;
			const ticketOpenCount = this.statistic?.ticket?.ticket_open_count ?? 0;

			this.assignStatsToSubmenu('user', supplierRequestedCount, 'supplier');
			this.assignStats('products', totalProductCount);
			this.assignStats('admin_brand', brandReviewCount);
			this.assignStats('admin_direct', directReviewCount);
			this.assignStats('admin_product_request', productRequestReviewCount);
			this.assignStats('ask-stocks', askStockNewCount);
			this.assignStats('ticket', ticketOpenCount);
		},
		getDisplayStats(value) {
			return value >= 100 ? '+99' : value;
		},
	},
	mounted() {
		this.closeSidebarMobile();
		this.fetchData();
	},
	watch: {
		getAskStockNewCount(newValue) {
			this.assignStats('ask-stocks', newValue);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/modules/_variables.scss';

.side-nav-item > .rl-active.side-nav-link {
	// color: #ffffff;
	font-weight: 600;
	position: relative;
	// background-color: rgba(202, 252, 240, 0.35);
	background-color: $color_ostock_primary_200; //rgb(2, 177, 195, 0.22);
	&::after {
		content: '';
		height: 100%;
		width: 5px;
		background-color: $color_ostock_primary;
		display: block;
		position: absolute;
		left: 0;
	}
	i {
		color: $color_ostock_primary;
	}
}
.side-nav-link {
	display: flex !important;
	justify-content: space-between;
	align-items: center;
	padding: 10px 15px 10px 30px !important;
	&.btn-create-order {
		justify-content: center;
		padding: 10px 30px !important;
	}
	&.active {
		background-color: rgb(2, 177, 195, 0.22);
		&::after {
			content: '';
			height: 100%;
			width: 5px;
			background-color: #00ab90;
			display: block;
			position: absolute;
			left: 0;
		}
	}
}
.is-absolute {
	position: absolute;
}
.side-nav-submenu {
	padding-left: 30px;
	.side-nav-link {
		&:hover {
			background-color: #e6f4ff;
		}
		&:active,
		&:focus {
			background-color: #e6f4ff;
		}
		&.router-link-active {
			background-color: #e6f4ff;
		}
	}
}
.arrow-submenu {
	transition: all 0.3s ease;
	&::before {
		font-size: 20px;
	}
	&.expanded {
		transform: rotate(90deg);
	}
}

.logo-lg img {
	max-width: 200px;
}

.sidebar-collapse-btn {
	content: "";
	width: 24px;
	height: 24px;
	border-radius: 4px;
	position: absolute;
	top: 28px;
	right: -13px;
	cursor: pointer;
	transition: all .25s ease-in-out;
	outline: 0;
	outline-offset: 0;
	border: none;
	padding: 0;
	background-color: #ff0000;
}

.ellipsis-text {
  white-space: nowrap; /* Teks hanya akan ditampilkan dalam satu baris */
  overflow: hidden; /* Potong teks yang melampaui batas elemen */
  text-overflow: ellipsis; /* Tambahkan elipsis (…) di akhir teks yang terpotong */
  width: 200px; /* Tentukan lebar elemen sesuai kebutuhan */
}
.body-condensed .sidebar-collapse-btn {
	-webkit-transform: rotate(180deg);
	transform: rotate(180deg);
}

@media (max-width: 480px) {
	.side-nav-link {
		padding: 10px 10px 10px 30px !important;
	}
}
</style>
